import React, { useState } from "react";
// import "./question.css";
import Amplify, { Auth } from 'aws-amplify';

function ReopenAssignment(props) {
  const [buttonText, setButtonText] = useState("ReOpen");

  const getToken = async () => {
    Auth.currentSession().then(res => {
      let accessToken = res.getAccessToken();
      let jwt = accessToken.getJwtToken();
      reopenevents1(props.category, props.eventid, jwt);
    });
  };

  const reopenevents1 = async (category, eventid, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify({ category: category, event_id: eventid })
    };

    const response = await fetch(`https://api.prod.quizwizard.net/quiz/deleteuseractivity`, requestOptions);
    const data = await response.json();
    props.closereopeneventwindow();
    setButtonText("ReOpen"); // Reset button text after process is complete
  };

  function reopenevents() {
    setButtonText("Reopening..."); // Set button text to "Reopening..." when process starts
    getToken();
  }

  return (
    <div className="mypopup-box">
      <div className="mybox">
        <span className="close-icon" onClick={props.closereopeneventwindow}>&#10005;</span>
        <label>
          Are you sure you want to Reopen {props.name}
        </label>
        <button className="popupbutton" onClick={reopenevents}>{buttonText}</button>
      </div>
    </div>
  );
}

export default ReopenAssignment;